<template>
    <div class="mt-10">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center py-5" v-if="downloading">
                    <b-spinner v-if="downloading" small label="Espere ..."></b-spinner>
                    <br>
                    <small>Espere un momento...</small>
                </div>
                <!-- <div class="col-lg-12" v-else>
                    <label for="">Listado de conversaciones</label>
                    <div class="conversation b-white p-2 rounded shadow-sm d-flex align-items-center justify-content-between mb-2"
                        v-for="conversation in conversationData"
                        :key="conversation.id">

                        <h5>{{conversation.from.name}} {{conversation.from.lname ? conversation.from.lname : ''}}</h5>
                        <router-link :to="'/conversation/' + conversation.conversation_url" class="btn b-orange mt-2 shadown-sm">
                            <i class="fas fa-comment"></i>
                            Ver Conversación
                        </router-link>
                    </div>

                </div>  -->
                <table class="table table-hover rounded">
                    <thead>
                        <th class="b-white"><i class="fas fa-user"></i> Usuario</th>
                        <th class="b-white">Opciones</th>
                    </thead>
                    <tbody>
                        <Conversation :conversation="conversation" v-for="conversation in conversationData" :key="conversation.id"/>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import Conversation from './components/Conversation'
export default {
    components:{
        'Conversation' : Conversation
    },
    data() {
        return {
            downloading: false,
            conversationData: []
        }
    },
    computed: {

    },
    methods:{
        loadMessages(){
            this.downloading = true
            this.api.get('conversation').then(({data}) => {
                this.conversationData = data
                this.downloading = false
            }).catch(err => {
                this.downloading = false                
            })
        }
    },
    created() {
        this.loadMessages()        
    },
}
</script>


// WEBPACK FOOTER //
// src/components/#pages/buzon/BuzonHome.vue